<template>
  <el-date-picker
    style="width: 280px"
    type="daterange"
    v-model="selectedValue"
    :clearable="clearable"
    :disabled="disabled"
    value-format="timestamp"
    :picker-options="datePickerOptions"
    range-separator="-"
    end-placeholder="结束日期"
    start-placeholder="开始日期"
  >
  </el-date-picker>
</template>

<script>
import genDateRangePickerOptions from '@/utils/genDateRangePickerOptions'
const dayRange = 24 * 60 * 60 * 1000

export default {
  name: 'filter-date-range',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    initRange: {
      type: Number,
      default: 30,
    },
    lastRange: {
      type: Number,
      default: 0,
    },
    range: {
      type: Number,
      default: 30,
    },
    startDate: { // 自定义起始日, 而非固定的今日
      type: Number,
    }
  },

  data() {
    return {
      datePickerOptions: {},
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },

  created() {
    this.datePickerOptions = genDateRangePickerOptions(this.range, this.startDate)
    const startTime = this.startDate ? this.startDate : Date.now()
    if (this.required) {
      this.selectedValue = [
        startTime - (this.initRange - 1) * dayRange,
        startTime - this.lastRange * dayRange,
      ]
    }
  },
}
</script>
